import { render } from "./statuses.vue?vue&type=template&id=6adeb632"
import script from "./statuses.vue?vue&type=script&lang=js"
export * from "./statuses.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__